// (function () {

// 	const footer = () => {
// 		const footerDetails = document.querySelectorAll(
// 			'.footer .accordion details',
// 		);
// 		footerDetails.forEach((targetDetail) => {
// 			targetDetail.addEventListener('click', () => {
// 				footerDetails.forEach((detail) => {
// 					if (detail !== targetDetail) {
// 						detail.removeAttribute('open');
// 					}
// 				});
// 			});
// 		});

// 	}

// 	document.addEventListener('shopify:section:load', footer);
// 	footer();

// })();
(function () {
	const footer = () => {
		const footerDetails = document.querySelectorAll(
			'.footer .accordion details',
		);

		// Ensure all accordion sections remain open
		footerDetails.forEach((targetDetail) => {
			// Force the "open" attribute to keep sections expanded
			targetDetail.setAttribute('open', '');

			// Disable toggle functionality without hiding headers
			const summary = targetDetail.querySelector('summary');
			if (summary) {
				// Prevent toggling behavior by disabling pointer events
				summary.style.pointerEvents = 'none';
				// Keep the summary visible for headers
				summary.style.display = 'block';
			}
		});
	};

	// Initialize the behavior
	document.addEventListener('shopify:section:load', footer);
	footer();
})();